// This file was generated by lezer-generator. You probably shouldn't edit it.
export const Duration = 1,
  Sign = 2,
  CompoundDuration = 3,
  NumberAndUnit = 4,
  Number = 5,
  Dot = 6,
  Unit = 7,
  Days = 8,
  Hours = 9,
  Minutes = 10,
  Seconds = 11,
  UnitAndNumber = 12,
  TimeFormat = 13,
  Colon = 14,
  PlainNumber = 15;
